module.exports = __webpack_public_path__ + "img/menu-icon-settings-white.5dc8e851.svg";